import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/main/services/google-analytics.service';
import { environment } from 'src/environments/environment';

export enum ServiceType {
  service,
  space
}
export interface IBoxData {
  title: string;
  image: string;
  desc: string;
  active?: boolean;
  url?: string;
  type?: ServiceType;
}
@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent implements OnInit {

  imagesUrl = environment.imagesUrl;
  serviceType = ServiceType;
  titleSectionProp: any = {
    title: 'השירותים שלנו',
    description: 'השירותים שלנו מותאמים למגוון לקוחות, מוזמנים לבחור את השירות שמתאים לכם...'
  };

  List: IBoxData[] = [
    {
      title: 'מסכי שילוט והכוונה',
      image: this.imagesUrl + 'our-services-icons/direction-screen.png',
      desc: 'לעיתים קשה למתמצא בבנייני משרדים ולמצוא את המשרד הרלוונטי. חברתנו פתחה מסך  הכוונה דיגיטלי אשר יאפשר לעוברים בבניין להתמצא בקלות. תנו למסך שלנו לעבוד עבורכם.',
      active: true,
      url: 'offices'
    },
    {
      title: 'מסך דיגיטלי בבניין מגורים',
      image: this.imagesUrl + 'our-services-icons/building-screen.png',
      desc: 'ועד בית/ חברת ניהול? הגעתם למקום הנכון! עם המסך שלנו תהפכו כל לובי לחדש, יוקרתי ודיגיטלי  עם תוכן מותאם לדיירי הבניין כגון חדשות בזמן אמת, תחזית מזג האויר, מוזיקת רקע נעימה ועוד..',
      url: 'buildings'
    },
    {
      title: 'מסכים לעסקים',
      image: this.imagesUrl + 'our-services-icons/business-screen.png',
      desc: 'כל עסק חייב מסכי שיווק פנים! המסכים שלנו ישדרגו את חלל הפנים של העסק שלך עם אלמנטים יחודיים אשר ילכדו את עיני הלקוח ,ישפרו את חווית הקניה שלו, יגדילו רווחיות ויחסכו לכם עלויות תפעול.',
      url: 'business'
    },
    {
      title: 'התקנת מצלמות',
      image: this.imagesUrl + 'our-services-icons/camera.png',
      desc: 'שירותי התקנת מצלמות ורישות מקצועי עם מערכת שליטה ובקרה',
      type: ServiceType.space
    },

    {
      title: 'מסכים בהתאמה אישית',
      image: this.imagesUrl + 'our-services-icons/custom-screen.png',
      desc: 'בית כנסת? אולם כנסים? בית מלון? הגיע הזמן להחליף את לוחות העץ העתיקים - חברתנו תפתח עבורכם מסך דיגיטלי בעיצוב אישי דרכו תוכלו להזין כל סוג של מידע בלחיצת כפתור ובזמן אמת.'
    },

    {
      title: 'מסכי קטלוג',
      image: this.imagesUrl + 'our-services-icons/catalog.png',
      desc: 'חברתנו פיתחה עמדת קטלוג דיגיטלית. מסך קטלוג אינטראקטיבי  המאפשר ללקוח לצאת לסיור דיגיטלי בין מוצריכם השונים ומייצר לו חווית קניה חדשנית ויקרתית.'
    }
  ];

  constructor(private googleAnalyticsService:GoogleAnalyticsService) { }

  ngOnInit(): void {
  }
  serviceClick(name:string){
    this.googleAnalyticsService.eventEmitter('enter service page','home page','click on service from home page - '+name)

  }
}
